module.exports = __webpack_public_path__ + "static/media/chat.f420bb05.svg";